// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.prequal-screen__container {
  display: flex;
  flex-direction: column;
  margin: 24px 0;
  max-width: 450px;
  flex: 1 0 auto;
}
.prequal-screen__name {
  font-weight: 600;
  font-size: 18px;
  letter-spacing: 0.75px;
  text-transform: uppercase;
  color: #3d7c54;
}
.prequal-screen__title {
  font-weight: 600;
  font-size: 28px;
}
@media (min-width: 950px) {
  .prequal-screen__title {
    font-size: 32px;
  }
}
.prequal-screen__subtitle {
  margin: 16px 0;
  font-size: 16px;
}
.prequal-screen__continue-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.prequal-screen__prequalified {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.prequal-screen__prequalified__text {
  margin: 0 8px;
  font-size: 16px;
}
.prequal-screen__view-letter {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.prequal-screen__view-letter__text {
  margin: 0 8px;
  font-size: 16px;
  color: #3d7c54;
  cursor: pointer;
}
.prequal-screen__pre-approval {
  display: flex;
  flex-direction: column;
  margin: 24px 0;
  padding: 24px;
  border-radius: 24px;
  background-color: #f1f9f1;
}
.prequal-screen__checklist__container {
  margin-bottom: 16px;
}
@media (min-width: 950px) {
  .prequal-screen__checklist__container {
    margin-bottom: 0;
  }
}
.prequal-screen__checklist__item {
  display: flex;
  flex-direction: row;
  margin: 8px 0;
}
.prequal-screen__checklist__text {
  margin-left: 8px;
  font-size: 12px;
}
.prequal-screen__checklist__icon {
  justify-self: center;
}
.prequal-screen__checklist__icon.\\--left-adjust {
  margin-left: 3px;
}
.prequal-screen__up-next {
  font-size: 18px;
  text-transform: uppercase;
  color: #3d7c54;
}
.prequal-screen__modal-title {
  font-weight: 600;
  font-size: 22px;
}
.prequal-screen__modal-subtitle {
  margin-top: 8px;
  font-size: 16px;
}
.prequal-screen__button {
  text-transform: inherit;
  font-weight: 500px;
  flex-grow: 0;
  width: 90%;
  margin: auto;
}
@media (min-width: 950px) {
  .prequal-screen__button {
    margin: 16px 0;
    width: 55%;
  }
}
.prequal-screen__disclosure {
  margin: 32px 0 8px;
  font-size: 10px;
  line-height: 15px;
}
.prequal-screen__animation {
  position: fixed;
  top: -10%;
  pointer-events: none;
  width: 100%;
  height: 100%;
}
@media (min-width: 950px) {
  .prequal-screen__animation {
    top: -25%;
  }
}
/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.br-pro-welcome__prequalify {
  display: flex;
  flex-direction: column;
  margin: 32px 0;
  padding: 24px;
  border-radius: 24px;
  background-color: #f1f9f1;
}
.br-pro-welcome__checklist__container {
  margin-bottom: 16px;
}
@media (min-width: 950px) {
  .br-pro-welcome__checklist__container {
    margin-bottom: 0;
  }
}
.br-pro-welcome__checklist__item {
  display: flex;
  flex-direction: row;
  margin: 8px 0;
}
.br-pro-welcome__checklist__text {
  margin-left: 8px;
  font-size: 12px;
}
.br-pro-welcome__checklist__icon {
  justify-self: center;
  height: 18px;
  width: 20px;
}
.br-pro-welcome__checklist__icon.\\--left-adjust {
  margin-left: 3px;
}
.br-pro-welcome__up-next {
  font-size: 18px;
  text-transform: uppercase;
  color: #3d7c54;
}
.br-pro-welcome__modal-title {
  font-weight: 600;
  font-size: 22px;
}
.br-pro-welcome__modal-subtitle {
  margin-top: 8px;
  font-size: 16px;
}
.br-pro-welcome__button {
  text-transform: inherit;
  font-weight: 500;
  flex-grow: 0;
  width: 90%;
  margin: auto;
}
@media (min-width: 950px) {
  .br-pro-welcome__button {
    margin: 16px 0;
    width: 65%;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/dist/interest/pages.css"],"names":[],"mappings":"AAAA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;AACd;AACA;EACE;IACE,cAAc;IACd,UAAU;EACZ;AACF;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,SAAS;EACT,oBAAoB;EACpB,WAAW;EACX,YAAY;AACd;AACA;EACE;IACE,SAAS;EACX;AACF;AAEA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,YAAY;AACd;AACA;EACE;IACE,cAAc;IACd,UAAU;EACZ;AACF","sourcesContent":["/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.prequal-screen__container {\n  display: flex;\n  flex-direction: column;\n  margin: 24px 0;\n  max-width: 450px;\n  flex: 1 0 auto;\n}\n.prequal-screen__name {\n  font-weight: 600;\n  font-size: 18px;\n  letter-spacing: 0.75px;\n  text-transform: uppercase;\n  color: #3d7c54;\n}\n.prequal-screen__title {\n  font-weight: 600;\n  font-size: 28px;\n}\n@media (min-width: 950px) {\n  .prequal-screen__title {\n    font-size: 32px;\n  }\n}\n.prequal-screen__subtitle {\n  margin: 16px 0;\n  font-size: 16px;\n}\n.prequal-screen__continue-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n.prequal-screen__prequalified {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.prequal-screen__prequalified__text {\n  margin: 0 8px;\n  font-size: 16px;\n}\n.prequal-screen__view-letter {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.prequal-screen__view-letter__text {\n  margin: 0 8px;\n  font-size: 16px;\n  color: #3d7c54;\n  cursor: pointer;\n}\n.prequal-screen__pre-approval {\n  display: flex;\n  flex-direction: column;\n  margin: 24px 0;\n  padding: 24px;\n  border-radius: 24px;\n  background-color: #f1f9f1;\n}\n.prequal-screen__checklist__container {\n  margin-bottom: 16px;\n}\n@media (min-width: 950px) {\n  .prequal-screen__checklist__container {\n    margin-bottom: 0;\n  }\n}\n.prequal-screen__checklist__item {\n  display: flex;\n  flex-direction: row;\n  margin: 8px 0;\n}\n.prequal-screen__checklist__text {\n  margin-left: 8px;\n  font-size: 12px;\n}\n.prequal-screen__checklist__icon {\n  justify-self: center;\n}\n.prequal-screen__checklist__icon.\\--left-adjust {\n  margin-left: 3px;\n}\n.prequal-screen__up-next {\n  font-size: 18px;\n  text-transform: uppercase;\n  color: #3d7c54;\n}\n.prequal-screen__modal-title {\n  font-weight: 600;\n  font-size: 22px;\n}\n.prequal-screen__modal-subtitle {\n  margin-top: 8px;\n  font-size: 16px;\n}\n.prequal-screen__button {\n  text-transform: inherit;\n  font-weight: 500px;\n  flex-grow: 0;\n  width: 90%;\n  margin: auto;\n}\n@media (min-width: 950px) {\n  .prequal-screen__button {\n    margin: 16px 0;\n    width: 55%;\n  }\n}\n.prequal-screen__disclosure {\n  margin: 32px 0 8px;\n  font-size: 10px;\n  line-height: 15px;\n}\n.prequal-screen__animation {\n  position: fixed;\n  top: -10%;\n  pointer-events: none;\n  width: 100%;\n  height: 100%;\n}\n@media (min-width: 950px) {\n  .prequal-screen__animation {\n    top: -25%;\n  }\n}\n\n/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.br-pro-welcome__prequalify {\n  display: flex;\n  flex-direction: column;\n  margin: 32px 0;\n  padding: 24px;\n  border-radius: 24px;\n  background-color: #f1f9f1;\n}\n.br-pro-welcome__checklist__container {\n  margin-bottom: 16px;\n}\n@media (min-width: 950px) {\n  .br-pro-welcome__checklist__container {\n    margin-bottom: 0;\n  }\n}\n.br-pro-welcome__checklist__item {\n  display: flex;\n  flex-direction: row;\n  margin: 8px 0;\n}\n.br-pro-welcome__checklist__text {\n  margin-left: 8px;\n  font-size: 12px;\n}\n.br-pro-welcome__checklist__icon {\n  justify-self: center;\n  height: 18px;\n  width: 20px;\n}\n.br-pro-welcome__checklist__icon.\\--left-adjust {\n  margin-left: 3px;\n}\n.br-pro-welcome__up-next {\n  font-size: 18px;\n  text-transform: uppercase;\n  color: #3d7c54;\n}\n.br-pro-welcome__modal-title {\n  font-weight: 600;\n  font-size: 22px;\n}\n.br-pro-welcome__modal-subtitle {\n  margin-top: 8px;\n  font-size: 16px;\n}\n.br-pro-welcome__button {\n  text-transform: inherit;\n  font-weight: 500;\n  flex-grow: 0;\n  width: 90%;\n  margin: auto;\n}\n@media (min-width: 950px) {\n  .br-pro-welcome__button {\n    margin: 16px 0;\n    width: 65%;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
